import {
  ACTIVE_FLOODING_ICONS_LAYER_ID,
  ACTIVE_FLOODING_LABELS_LAYER_ID,
  ACTIVE_FLOODING_SOURCE_ID,
  FLOODING_ACTIVE_LABELS_MIN_ZOOM,
} from './FloodingsLayer.constants';
import { FloodingsLayerBase, FloodingsLayerConfig } from './FloodingsLayerBase';
import { FloodingsLayerProps } from './FloodingsLayer.utils';

const config: FloodingsLayerConfig = {
  sourceId: ACTIVE_FLOODING_SOURCE_ID,
  iconsLayerId: ACTIVE_FLOODING_ICONS_LAYER_ID,
  labelsLayerId: ACTIVE_FLOODING_LABELS_LAYER_ID,
  labelsMinZoom: FLOODING_ACTIVE_LABELS_MIN_ZOOM,
  filterEvent: (e) => e.isActive,
};

export const ActiveFloodingsLayer = (
  props: FloodingsLayerProps,
): JSX.Element => <FloodingsLayerBase {...props} config={config} />;
